import React from 'react';
import BEMHelper from '@ynap/bem-helper';
import { formatPrice } from '@ynap/intl-formatters';
import { string, object, bool } from 'prop-types';

const bem = new BEMHelper('PriceInformationCard');

const propTypes = {
    product: object,
    messages: object,
    locale: string,
    country: string,
    name: string,
    discountPercentage: string,
    isEUcountry: bool,
    showMinimumPriceLabel: bool,
    privateLabel: string,
};

const PriceInformationCard = (props) => {
    const { product, messages, locale, discountPercentage, isEUcountry, showMinimumPriceLabel, country, privateLabel } = props;

    const { price } = product || {};

    const getPriceToShow = (price, currency) => {
        return currency?.label && price && formatPrice(price, currency?.label, locale);
    };

    const getMinimumPriceMessage = (minimumPrice, minPriceDiscount, finalPrice) => {
        if (minimumPrice < finalPrice) {
            return (
                <span>
                    {messages?.price?.minimumPrice?.()} {getPriceToShow(minimumPrice, price?.currency)}
                </span>
            );
        } else if (minimumPrice > finalPrice) {
            return (
                <strong>
                    {messages?.price?.minimumPrice?.()} <s>{getPriceToShow(minimumPrice, price?.currency)}</s>{' '}
                    {messages?.price?.discountPercentage?.({ discountPercentage: minPriceDiscount })}
                </strong>
            );
        } else {
            return <span>{messages?.price?.minimumPriceEqual?.()}</span>;
        }
    };

    const renderDiscountLabels = () => {
        if (privateLabel) {
            return (
                <>
                    <s className={bem('priceMessage')}>{messages?.price?.originalPrice?.()}</s>
                    <s className={bem('originalPrice')}>{getPriceToShow(price?.originalPrice, price?.currency)}</s>
                </>
            );
        } else if (!privateLabel && country !== 'US') {
            return (
                <>
                    <span className={bem('priceMessage')}>{messages?.price?.wasPrice?.()}</span>
                    <span className={bem('rrp')}>{getPriceToShow(price?.originalPrice, price?.currency)}</span>
                </>
            );
        } else {
            return <span className={bem('thirdPartyUsModifier')}>{getPriceToShow(price?.originalPrice, price?.currency)}</span>;
        }
    };

    return (
        <div className={bem()}>
            <div className={bem('informationContainer')}>
                <div className={bem('designerContainer')}>
                    <span className={bem('designerStyle')}>{messages?.product?.Brand()}</span>
                    <div className={bem('badgeContainer')}>
                        <span className={bem('badgeStyle')}>{messages?.product?.Illustrative()}</span>
                    </div>
                </div>
                <span className={bem('categoryStyle')}>{messages?.product?.productTitle()}</span>
            </div>
            <ul className={bem('ulContainer')}>
                <li className={bem('priceContainer')}>
                    <div className={bem('numberContainer')}>
                        <span className={bem('number')}>1</span>
                    </div>
                    <span className={bem('price')}>{getPriceToShow(price?.finalPrice, price?.currency)}</span>
                </li>
                {showMinimumPriceLabel && isEUcountry && showMinimumPriceLabel && (
                    <li className={bem('minimumPriceMessage')}>
                        <div className={bem('numberContainer')}>
                            <span className={bem('number')}>2</span>
                        </div>
                        <span className={bem('priceMessage', showMinimumPriceLabel ? 'show' : null)}>
                            {getMinimumPriceMessage(price?.minimumPrice, price?.minPriceDiscount, price?.finalPrice)}
                        </span>
                    </li>
                )}
                <li className={bem('discountList')}>
                    <div className={bem('numberContainer')}>
                        <span className={bem('number')}>{showMinimumPriceLabel && isEUcountry && showMinimumPriceLabel ? '3' : '2'}</span>
                    </div>
                    <span className={bem('discountContainer')}>
                        {renderDiscountLabels()}
                        <div className={bem('discount')}>{messages.price.discountPercentage({ discountPercentage })}</div>
                    </span>
                </li>
            </ul>
        </div>
    );
};

PriceInformationCard.propTypes = propTypes;

export default PriceInformationCard;
